// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__finalize',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Methods
    methods: {
        // #region Command
        async onCommand(args) {
            await this.$emit('command', args);
        },
        // #endregion
    }
    // #endregion
});
// #endregion
